module.exports = __webpack_public_path__ + "static/media/transparentCross.7a063df4.png";